import TopBar from "../Components/TopBar";
import {Link} from "react-router-dom";
import Footer from "../Components/Footer";

function ErrorPage() {
    return (
        <div className="flex flex-col min-h-screen">
            <TopBar title="Ingenjörskompassen" count={null} />
            <div className="w-full bg-white py-8 xl:py-16">
                <div className="container max-w-3xl font-sweing">
                    <h2 className="text-4xl font-medium text-black mb-8">Förlåt vi hittar inte sidan du ville besöka.</h2>
                    <p className="font-body text-lg">Har du klickat på en extern länk eller skrivit in adressen själv, kontrollera att du har skrivit rätt och försök igen. Kontaka gärna <Link className="underline" to="mailto:webmaster@sverigesingenjorer.se">webmaster@sverigesingenjorer.se</Link> och meddela oss om någon länk inte fungerar så att vi kan åtgärda det på webbplatsen.</p>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default ErrorPage;